import React from 'react'

import { HorizontalLine, VerticalLine } from '../shapes/Line'
import FlexGrid, { FlexCol } from './FlexGrid'
import Separator from '../helpers/Separator'
import { COLORS } from '@btime/constants'

export const SubItem = ({ disabled, noLine, children, separatorWeight }) => (
  <FlexGrid justify="stretch" align="center">
    {!disabled && (
      <FlexCol width="1.5rem">
        <HorizontalLine width="1px" lineColor={noLine ? COLORS.transparent : COLORS.light3} />
      </FlexCol>
    )}

    {separatorWeight > 0 && <Separator weight={separatorWeight || 0} vertical />}

    <FlexCol flex={1}>{children}</FlexCol>
  </FlexGrid>
)

export const SubItemsWrapper = ({ disabled, children }) => (
  <FlexGrid align="stretch" justify="stretch">
    <Separator weight={8} vertical />
    <FlexCol>
      <VerticalLine width="1px" lineColor={COLORS.light3} fullHeight />
    </FlexCol>

    <FlexCol flex={1}>{children}</FlexCol>
  </FlexGrid>
)
